import en from './en.json';
import {notifyException} from 'utilities/analytics/bugsnag';
import railsData from 'utilities/rails-data';

const i18nArgs = {
  id: 'ServicesMarketplace::SavedExperts',
  fallback: en,
  async translations() {
    const locale = railsData('locale') || 'en';

    try {
      const dictionary = await import(
        /* webpackChunkName: "ServicesMarketplace::SavedExperts-i18n-[request]" */ `./${locale}.json`
      );
      return dictionary;
    } catch (error) {
      notifyException({
        errorName: 'I18n:ServicesMarketplace::SavedExperts',
        error,
      });
    }
    return en;
  },
};

export default i18nArgs;
